export const getToken = store => store.local.token
export const getFirstTime = store => store.local.isFirstTime
export const getLang = store => store.local.lang
export const getLastConfirmedPayment = store => store.local.lastConfirmedPayment
export const getLastTakeoutReady = store => store.local.lastTakeoutReady
